import type { TUltimoAtendimento } from '@/features/atendimento/interfaces'
import { HttpService } from '@/infra'

export class GetUltimosAtendimentosService extends HttpService {
  async execute(): Promise<TUltimoAtendimento[]> {
    const response = await this.http.get<TUltimoAtendimento[]>('api/v2/Atendimento/ultimosAtendimentos')
    return response.data
  }
}
